/* ==========================================================================
   Homellence – U5 (Runde 38) · Kopfzeile beim Herunterscrollen ausblenden
                  K2 (Runde 46) · Auch am Handy, gegen die Adressleiste
                                  abgesichert

   Nach unten gleitet die Kopfzeile weg, bei der kleinsten Bewegung nach
   oben ist sie sofort wieder da. Ganz oben steht sie immer.

   Verschoben wird die **klebende** Hülle (`.hl-section-header`), nicht ein
   Element darin: Ein inneres Element wegzuschieben liesse die Hülle als
   unsichtbaren Block über dem Inhalt stehen, der weiter Klicks fängt.

   Bewegt wird über `transform`. Das kostet kein Layout und damit kein
   Springen des Inhalts - CLS bleibt 0. Aus demselben Grund bleibt die
   Kopfzeile im Fluss: Anker und Sprungziele behalten ihre Position.

   Die Kopfzeile bleibt stehen, solange dort etwas offen ist:
   - eine Schublade (Menü, Warenkorb) - erkennbar an `hl-scroll-locked`
     am <body>, das `hl-ui.js` beim Öffnen setzt,
   - die Suche oder ein Untermenü (`aria-expanded="true"`),
   - die Länder- und Sprachauswahl (`[data-hl-loc][open]`, seit N1),
   - oder der Tastaturfokus steht in der Kopfzeile.

   Das Skript lädt nur, wenn die Einstellung an ist.

   ## K2 (Runde 46) · Warum das am Handy vorher nicht trug

   In Runde 44 fiel die Mechanik am Handy ganz weg. Der Grund war richtig
   und gilt weiter: Die Adressleiste des Browsers fährt beim Scrollen ein
   und aus. Dabei ändert sich der Scrollstand, ohne dass der Finger sich
   bewegt hätte, und der Browser feuert dafür eigene `scroll`-Ereignisse.
   Eine Entscheidung, die am Abstand zweier Scrollstände hängt, liest das
   als Fingerbewegung und blendet aus, wo niemand gescrollt hat - oder
   bringt die Leiste nicht zurück, wo jemand nach oben gewischt hat.

   Kristin möchte das Ausblenden am Handy trotzdem. Drei Dinge machen es
   jetzt tragfähig:

   1. **Die Adressleiste wird erkannt und übersprungen.** Fährt sie ein
      oder aus, ändert sich `visualViewport.height`. Genau die Schritte,
      in denen das passiert, zählen nicht als Fingerbewegung. Das ist der
      einzige Weg, der die Ursache trifft statt ihrer Wirkung.

   2. **Es zählt die aufsummierte Bewegung, nicht der einzelne Ruck.**
      Nach unten braucht es 60 px am Stück, nach oben genügen 4 px. Ein
      Richtungswechsel setzt die Summe zurück. Ein einzelner Sprung der
      Adressleiste, der Punkt 1 durchrutscht, reicht damit nicht mehr aus,
      und eine kleine Bewegung nach oben wirkt trotzdem sofort.

   3. **Die Enden der Seite sind ausgenommen.** Am oberen und unteren Rand
      federt die Seite zurück (Gummiband). Diese Rückfederung ist keine
      Fingerbewegung und wird nicht gewertet.

   Bei vergrösserter Ansicht (`visualViewport.scale > 1`) bleibt die
   Kopfzeile ganz stehen. Wer hineinzoomt, sucht eine Stelle und nicht eine
   Leiste, die sich wegbewegt.
   ========================================================================== */
(function () {
  'use strict';

  /* Nach oben genügt eine kleine Bewegung, nach unten braucht es einen
     ordentlichen Zug. Beide Grenzen zählen die **aufsummierte** Bewegung
     einer Richtung, nicht den einzelnen Ruck, und beide zählen
     einschliesslich: genau 4 px nach oben zeigen die Kopfzeile schon. */
  var HOCH = 4;
  var RUNTER = 60;

  /* Ab dieser Änderung der sichtbaren Fensterhöhe gilt ein Schritt als
     Adressleiste und nicht als Finger. 1 px fängt auch das Runden ab. */
  var LEISTE = 1;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var vv = window.visualViewport || null;

  function offenInKopf(gruppe, huelle) {
    if (document.body.classList.contains('hl-scroll-locked')) return true;
    if (huelle.querySelector('[aria-expanded="true"]')) return true;

    /* K2 · Die Länder- und Sprachauswahl ist ein `details` und meldet
       ihren Zustand über `open`, nicht über `aria-expanded`. Gefragt wird
       gezielt nach ihr und nicht nach `details[open]` allgemein: In der
       Menü-Schublade stehen weitere `details`, die auch dann offen
       bleiben, wenn die Schublade längst zu ist. */
    if (huelle.querySelector('[data-hl-loc][open]')) return true;

    var aktiv = document.activeElement;
    if (aktiv && aktiv !== document.body && huelle.contains(aktiv)) return true;

    return false;
  }

  function start(gruppe) {
    /* Die klebende Hülle ist der Section-Wrapper. Ohne ihn gibt es nichts
       zu verschieben - dann bleibt alles, wie es ist. */
    var huelle = gruppe.closest('.hl-section-header') || gruppe.closest('.shopify-section');
    if (!huelle) return;

    huelle.classList.add('hl-header--hideable');

    var letzter = stand();
    var summe = 0;
    var weg = false;
    var geplant = false;
    var sichtHoehe = vv ? vv.height : 0;

    function stand() {
      return window.pageYOffset || document.documentElement.scrollTop || 0;
    }

    function hoehe() {
      return huelle.getBoundingClientRect().height || 1;
    }

    /* Wie weit die Seite überhaupt scrollen kann. Alles darüber hinaus ist
       Gummiband. */
    function grenze() {
      var doc = document.documentElement;
      return Math.max(0, doc.scrollHeight - (vv ? vv.height : window.innerHeight));
    }

    function zeigen() {
      summe = 0;
      if (!weg) return;
      weg = false;
      huelle.classList.remove('hl-header--away');
    }

    function verstecken() {
      summe = 0;
      if (weg) return;
      weg = true;
      huelle.classList.add('hl-header--away');
    }

    function rechnen() {
      geplant = false;

      var jetzt = stand();
      var diff = jetzt - letzter;
      letzter = jetzt;

      /* K2 · Punkt 1: Hat sich die sichtbare Fensterhöhe geändert, ist die
         Adressleiste gefahren. Der Schritt zählt nicht. */
      if (vv) {
        if (Math.abs(vv.height - sichtHoehe) > LEISTE) {
          sichtHoehe = vv.height;
          summe = 0;
          return;
        }
        /* Vergrösserte Ansicht: Kopfzeile stehen lassen. */
        if (vv.scale > 1) {
          zeigen();
          return;
        }
      }

      /* Ganz oben immer sichtbar. Der Vergleich gegen die Kopfzeilenhöhe
         verhindert, dass sie schon beim ersten Pixel verschwindet. */
      if (jetzt <= hoehe()) {
        zeigen();
        return;
      }

      if (offenInKopf(gruppe, huelle)) {
        zeigen();
        return;
      }

      /* K2 · Punkt 3: Gummiband an den Enden nicht werten. Oben ist durch
         die Abfrage darüber schon erledigt, unten hier. */
      if (jetzt >= grenze() - 2) {
        summe = 0;
        return;
      }

      /* K2 · Punkt 2: aufsummierte Bewegung. Ein Richtungswechsel setzt
         zurück, damit sich Hin und Her nicht zu einem Zug addiert. */
      if (diff > 0) {
        if (summe < 0) summe = 0;
        summe += diff;
      } else if (diff < 0) {
        if (summe > 0) summe = 0;
        summe += diff;
      } else {
        return;
      }

      if (summe >= RUNTER) {
        verstecken();
      } else if (summe <= -HOCH) {
        zeigen();
      }
    }

    function planen() {
      if (geplant) return;
      geplant = true;
      window.requestAnimationFrame(rechnen);
    }

    window.addEventListener('scroll', planen, { passive: true });
    window.addEventListener('resize', planen, { passive: true });

    /* Die Adressleiste meldet sich hier zuerst. Den neuen Wert sofort
       übernehmen und die Summe verwerfen, damit der nächste echte
       Scrollschritt sauber bei null anfängt. */
    if (vv) {
      vv.addEventListener('resize', function () {
        sichtHoehe = vv.height;
        letzter = stand();
        summe = 0;
      });
    }

    /* Wer mit der Tabulatortaste in die Kopfzeile springt, soll sie sehen.
       `focusin` steigt auf, ein einzelner Horcher am Dokument genügt. */
    document.addEventListener('focusin', function (event) {
      if (huelle.contains(event.target)) zeigen();
    });

    /* Öffnet sich eine Schublade, die Suche oder die Länderauswahl,
       während die Kopfzeile weg ist, kommt sie zurück. Beides läuft über
       Klicks in der Kopfzeile, also genügt dieser eine Horcher. */
    huelle.addEventListener('click', zeigen);

    /* K2 · `details` meldet sein Auf- und Zuklappen mit `toggle`. Das
       feuert auch bei Tastaturbedienung, wo kein Klick kommt. `toggle`
       steigt nicht auf, deshalb der Horcher in der Erfassungsphase. */
    huelle.addEventListener(
      'toggle',
      function (event) {
        if (event.target.hasAttribute && event.target.hasAttribute('data-hl-loc')) zeigen();
      },
      true
    );

    /* Bei reduzierter Bewegung gibt es keine Animation (das steht im CSS),
       das Ausblenden selbst bleibt. Ändert sich die Einstellung, wird die
       Kopfzeile einmal gezeigt, damit niemand vor einer weggeschobenen
       Leiste sitzt. */
    if (reduced.addEventListener) reduced.addEventListener('change', zeigen);
    else if (reduced.addListener) reduced.addListener(zeigen);

    /* Beim Drehen des Geräts ändert sich alles auf einmal. Einmal zeigen
       und neu anfangen. */
    window.addEventListener('orientationchange', function () {
      sichtHoehe = vv ? vv.height : 0;
      letzter = stand();
      zeigen();
    });

    rechnen();
  }

  function bereit() {
    var gruppe = document.querySelector('[data-hl-hide-on-scroll="true"]');
    if (gruppe) start(gruppe);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bereit);
  } else {
    bereit();
  }
})();
